<template>
  <div :class="['list', styleList[displayStyle]]">
    <div class="rank" v-if="displayStyle===11" @click="goDetail(data[0])">
      <img :src="data[0].cover" alt="" />
      <div class="info">
        <p class="title">{{ data[0].title }}</p>
        <p class="summary">{{ data[0].summary }}</p>
        <div class="tag-list">
          <Tag v-for="tag in data[0].tags" :key="tag.id">
            {{ sliceStr(tag.name, 5, '..') }}
          </Tag>
        </div>
      </div>
    </div>
    <div class="inner">
      <div class="item" v-for="(item, index) in data" :key="index" @click="goDetail(item)">
        <img :src="item.cover" alt="" />
        <div class="info">
          <p class="title">{{ item.title }}</p>
          <p class="summary" v-if="displayStyle===4">{{ item.summary }}</p>
          <div class="tag-list" v-if="displayStyle===4">
            <Tag v-for="tag in item.tags" :key="tag.id">
              {{ sliceStr(tag.name, 5, '..') }}
            </Tag>
          </div>
          <p class="type" v-else-if="needTypeDisplay">{{ sliceTag(item.tags || []) }}</p>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Tag from '@/components/Tag.vue';
import { sliceStr } from '@/utils';

export default {
  components: { Tag },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    needTypeDisplay: {
      type: Boolean,
      default: false,
    },
    displayStyle: {
      type: Number,
      default: 10, // hor: 横版，por: 竖版， por-3: 竖版三列，por-auto: 竖版不限，content: 左右图文
    },
  },
  data() {
    return {
      styleList: {
        '10': 'por-3', // 三宫格
        '11': 'por-3-content', // 三宫格榜单
        '7': 'por-auto', // 榜单
        '4': 'content', // 普通列表
      },
    };
  },
  methods: {
    sliceStr(...args) {
      return sliceStr(...args);
    },
    sliceTag(arr = []) {
      return arr?.map((im) => (im.name))?.join('/');
    },
    goDetail(item) {
      this.$emit('goDetail', item.novel_id || item.id || '');
    },
  },
};
</script>
<style lang="less" scoped>
.list {
  padding: 8px 0 8px 16px;
  .inner {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .info {
    display: flex;
    flex-direction: column;
    .tag-list {
      margin-top: auto;
    }
  }
  .summary {
    font-size: @fontSmall;
    color:@gray;
    .overflow-ellipsis(2);
  }
  .item {
    width: 156px;
    margin-bottom: 16px;
    img {
      width: 156px;
      height: 200px;
      border-radius: 12px;
    }
    .title {
      line-height: 24px;
      color:@black;
      font-size: @fontMedium;
      font-weight: 700;
      .overflow-ellipsis(1);
    }
    .type {
      color: #757575;
      font-size: @fontSmall;
      .overflow-ellipsis(1);
    }
  }
  &.hor {
    .item {
      width: 156px;
      img {
        width: 156px;
        height: 117px;
      }
    }
  }
  &.por-3 {
    padding-right: 16px;
    .inner {
      justify-content: unset;
    }
    .item {
      width: 99px;
      max-width: 32%;
      img {
        width: 99px;
        height: 120px;
      }
      &:nth-child(3n-1){
        margin: 0 15px;
      }
    }
  }
  &.por-auto {
    padding: 8px 0px 8px 16px;
    .inner {
      display: flex;
      flex-wrap: nowrap;
      overflow-y: auto;
    }
    .item {
      width: 120px;
      flex-shrink: 0;
      margin-right: 16px;
      img {
        width: 120px;
        height: 160px;
      }
    }
  }
  &.content {
    .item {
      width: 100%;
      display: flex;
      .title {
        font-size: @fontMedium;
        margin-bottom: 8px;
      }
      img {
        width: 94px;
        height: 120px;
        flex-shrink: 0;
        margin-right: 12px;
      }
    }
  }
  &.por-3-content {
    .rank {
      display: flex;
      margin-bottom: 12px;
      padding-right: 16px;
      .title {
        font-size: @fontMedium;
        font-weight: 700;
        margin-bottom: 8px;
      }
      img {
        width: 120px;
        height: 160px;
        margin-right: 12px;
        border-radius: 12px;
      }
    }
    .inner {
      display: flex;
      flex-wrap: nowrap;
      overflow-y: auto;
      justify-content: flex-start;
    }
    .item {
      width: 120px;
      flex-shrink: 0;
      margin-right: 16px;
      img {
        width: 120px;
        height: 160px;
      }
      &:first-child {
        display: none;
      }
    }
  }
  .novel-tag {
    margin-right: 4px;
    margin-bottom: 8px;
  }
}
</style>
